export default "__VITE_ASSET__CEUEKZJj__"